RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const FbPostDetailsSocialEngagementBreakdownView = widgets.PostDetailsColumnView.extend({
        columnWidth: 4
    });

    const FbPostDetailsSocialEngagementBreakdownWidget = widgets.PostDetailsWidgetBase.extend({
        title: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_title,
        description: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_description,
        alert: function () {
            const me = this;
            const description = RivalIQ.strings.facebook_insights_post_detail_data_warning_breakout_description;
            return App.utils.getUnderReportingAlert(me.curation, description);
        },
        view: FbPostDetailsSocialEngagementBreakdownView,
        widgetDefinitions: function () {
            const me = this;
            const metric = me.metric;

            const widgets = [
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PERCENTAGE,
                    title: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_organic_title,
                    barTitle: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_organic_bar_title,
                    hideBar: true,
                    formatter: RivalIQ.formatter.noFacebookNegativeWrapper(RivalIQ.formatter.formats.percentAbsolute),
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ORGANIC_ENGAGEMENT', {
                        name: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_organic_title,
                        description: RivalIQ.metrics.descriptions.FACEBOOK_INSIGHTS_POST_ORGANIC_ENGAGEMENT_RATE.description
                    }),
                    divisor: metric.create('FACEBOOK_INSIGHTS_POST_ORGANIC_TOTAL_REACH')
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_PERCENTAGE,
                    title: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_paid_title,
                    barTitle: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_paid_bar_title,
                    hideBar: true,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_PAID_ENGAGEMENT', {
                        name: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_paid_title,
                        description: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_paid_description
                    }),
                    divisor: metric.create('FACEBOOK_INSIGHTS_POST_PAID_REACH')
                },

                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_BREAKOUT,
                    hideMetric: true,
                    useMax: true,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        name: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_comparison_title,
                        description: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_engagement_rate_comparison_info
                    }),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            {
                                semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_ENGAGEMENT_RATE',
                                name: RivalIQ.strings.facebook_insights_post_detail_organic
                            },
                            {
                                semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_ENGAGEMENT_RATE',
                                name: RivalIQ.strings.facebook_insights_post_detail_paid
                            }
                        ]
                    })
                },


                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_ORGANIC_ENGAGEMENT', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_REACTIONS',
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_COMMENTS',
                            'FACEBOOK_INSIGHTS_POST_ORGANIC_SHARES'
                        ]
                    })
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LEGEND,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_PAID_ENGAGEMENT', {
                        submetrics: [
                            'FACEBOOK_INSIGHTS_POST_PAID_REACTIONS',
                            'FACEBOOK_INSIGHTS_POST_PAID_COMMENTS',
                            'FACEBOOK_INSIGHTS_POST_PAID_SHARES'
                        ]
                    })
                },
                {
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_BREAKOUT,
                    hideMetric: true,
                    metric: metric.create('FACEBOOK_INSIGHTS_POST_AND_SHARES_ENGAGEMENT_TOTAL', {
                        description: RivalIQ.strings.facebook_insights_post_detail_social_engagement_breakdown_posts_and_shares_comparison_info
                    }),
                    chart: metric.create('FACEBOOK_INSIGHTS_POST_DETAILS', {
                        submetrics: [
                            {
                                semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_ENGAGEMENT',
                                name: RivalIQ.strings.facebook_insights_post_detail_organic
                            },
                            {
                                semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_ENGAGEMENT',
                                name: RivalIQ.strings.facebook_insights_post_detail_paid
                            }
                        ]
                    })
                }
            ];

            return widgets;
        },
        filter: function () {
            const me = this;

            return !me.curation.hasBoostedSpend;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_POST_SOCIAL_ENGAGEMENT_BREAKDOWN, FbPostDetailsSocialEngagementBreakdownWidget);

});
